import { ApiClient } from './client.js'
import { SUBSCRIPTION_INVOICES } from './resources.js'

const client = new ApiClient()

export default {
  retrieve (invoiceId) {
    return client.get(`${SUBSCRIPTION_INVOICES}${invoiceId}/`)
  },

  pdf (invoiceId) {
    return client.get(`${SUBSCRIPTION_INVOICES}${invoiceId}/pdf/`, {
      responseType: 'arraybuffer'
    })
  },

  list () {
    return client.get(`${SUBSCRIPTION_INVOICES}`)
  },

  listAll () {
    return client.getAll(`${SUBSCRIPTION_INVOICES}`)
  }
}
